<ftr-badge-foundation [color]="badgeColor" [text]="mfaStatus"></ftr-badge-foundation>
